import { Box, Table } from '@nimbus-ds/components';
import { Repeater } from 'commons/components';
import { MetaplansListDesktopRowSkeleton } from './MetaplansListDesktopRowSkeleton';
import { MetaplansListHeader } from './MetaplansListHeader';

const metaplansListRow = () => <MetaplansListDesktopRowSkeleton />;

export function MetaplansListDesktopSkeleton() {
  return (
    <Box flexDirection="column" gap="2" display="flex">
      <Table>
        <MetaplansListHeader />
        <Table.Body>
          <Repeater times={5} item={metaplansListRow} />
        </Table.Body>
      </Table>
    </Box>
  );
}
